import { Graph, Node, Shape } from '@antv/x6';

const PORT_FILL = {
  DEFAULT: '#f2f2f2',
  LAN: '#ffe449ff',
  WAN: '#3d98ffff',
  FIREWALL_IN: '#ffe7a0',
  FIREWALL_OUT: '#97c0ff',
};

// 交换机
class Switch extends Node {}

Switch.config({
  width: 108,
  height: 55,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/switch.png'),
      width: 108,
      height: 55,
    },
    text: {
      refX: '50%',
      refY: 72,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '交换机',
      fontSize: 12
    },
  },
  ports: {
    items: [
      {
        group: 'inet',
      },
      {
        group: 'inet',
      },
      {
        group: 'inet',
      },
      {
        group: 'inet',
      },
      {
        group: 'inet',
      },
    ],
    groups: {
      inet: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
        ],

        position: {
          name: 'top',
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.LAN,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -8,
            y: -20,
          },
        },
      },
    },
  }
});

Graph.registerNode('Switch', Switch);

// 计算机
export class PC extends Node {}

PC.config({
  width: 82,
  height: 72,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/pc.png'),
      width: 82,
      height: 72,
    },
    text: {
      refX: '50%',
      refY: 90,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '计算机',
      fontSize: 12
    },
  },
  ports: {
    items: [
      {
        group: 'inet',
      },
    ],
    groups: {
      inet: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
        ],

        position: {
          name: 'bottom',
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.DEFAULT,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -8,
            y: 30,
          },
        },
      },
    },
  }
});

Graph.registerNode('PC', PC);

// DHCP服务器
// !!! 去除了租约时间，增补了IP和子网掩码，DHCP服务器本身也是需要IP地址的
class DHCPServer extends Node {}

DHCPServer.config({
    width: 108,
    height: 75,
    markup: [
      {
        tagName: 'image',
        selector: 'body',
      },
      {
        tagName: 'text',
        selector: 'label',
      },
    ],
    attrs: {
      body: {
        href: require('../../assets/icon/dhcp_server.png'),
        width: 108,
        height: 75,
      },
      text: {
        refX: '50%',
        refY: 90,
        textAnchor: 'middle',
        textVerticalAnchor: 'middle',
        text: 'DHCP服务器',
        fontSize: 12
      },
    },
    ports: {
      items: [
        {
          group: 'inet',
        },
      ],
      groups: {
        inet: {
          markup: [
            {
              tagName: 'rect',
              selector: 'rect',
            },
          ],

          position: {
            name: 'bottom',
          },

          attrs: {
            rect: {
              magnet: true,
              stroke: 'gray',
              fill: PORT_FILL.DEFAULT,
              strokeWidth: 2,
              width: 16,
              height: 16,
              x: -8,
              y: 30,
            },
          },
        },
      },
    }
});

Graph.registerNode('DHCPServer', DHCPServer);

// 移动终端
class MobileDevice extends Node {};

MobileDevice.config({
  width: 72,
  height: 60,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/phone.png'),
      width: 72,
      height: 60,
    },
    text: {
      refX: '50%',
      refY: 90,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '移动终端',
      fontSize: 12
    },
  },
});

Graph.registerNode('MobileDevice', MobileDevice);

// 无线接入点
class AP extends Node {}

AP.config({
  width: 72,
  height: 60,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/ap.png'),
      width: 72,
      height: 60,
    },
    text: {
      refX: '50%',
      refY: 75,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '无线接入点',
      fontSize: 12
    },
  },
  ports: {
    items: [
      {
        group: 'inet',
      },
    ],
    groups: {
      inet: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
        ],

        position: {
          name: 'bottom',
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.DEFAULT,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -8,
            y: 30,
          },
        },
      },
    },
  }
});

Graph.registerNode('AP', AP);


// 无线路由器：家庭网关
class HomeGateway extends Node {}

HomeGateway.config({
  width: 90,
  height: 66,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/home_gateway.png'),
      width: 72,
      height: 60,
    },
    text: {
      refX: '50%',
      refY: 75,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '无线路由器',
      fontSize: 12
    },
  },
  ports: {
    items: [
      {
        group: 'inetLAN',
        attrs: {
          text: {          // 标签选择器
            text: 'LAN', // 标签文本
          }
        },
      },
      {
        group: 'inetLAN',
      },
      {
        group: 'inetLAN',
      },
      {
        group: 'inetLAN',
      },
      {
        group: 'inetWAN',
        attrs: {
          rect: {
            y: 30,
          },
          text: {          // 标签选择器
            text: 'WAN', // 标签文本
          },
        },
      },
    ],
    groups: {
      inetLAN: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
        ],

        position: {
          name: 'top',
        },

        label: {
          position: {
            name: 'top',
            args: {
              x: -28,
              y: -8
            }
          },
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.LAN,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -8,
            y: -20,
          },
          label:{
            
          }
        },
      },
      inetWAN: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
        ],

        position: {
          name: 'bottom',
        },

        label: {
          position: {
            name: 'bottom',
            args: {
              x: -24,
              y: 35
            }
          },
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.WAN,
            strokeWidth: 2,
            width: 16,
            height: 16,
          },
          label:{
            
          }
        },
      },
    },
  }
});

Graph.registerNode('HomeGateway', HomeGateway);


// 调制解调器（无配置）
// 1. 充当PPPOE服务器，向拨号的终端提供公网IP，DNS和公网网关
// 2. 充当公网模拟器，对于PPPOE链路请求的任意IP的ICMP报文进行响应
class Modem extends Node {}

Modem.config({
  width: 72,
  height: 60,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'image',
      selector: 'internet',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/modem.png'),
      width: 72,
      height: 60,
    },
    internet: {
      href: require('../../assets/icon/internet.png'),
      width: 72,
      height: 60,
      y: -6,
      x: 65,
    },
    text: {
      refX: '50%',
      refY: 72,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '调制解调器',
      fontSize: 12
    },
  },
  ports: {
    items: [
      {
        group: 'inet',
      },
    ],
    groups: {
      inet: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
        ],

        position: {
          name: 'top',
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.WAN,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -8,
            y: -20,
          },
        },
      },
    },
  }
});

Graph.registerNode('Modem', Modem);

// 路由器
// 变更，网卡一拆二，公网配置mode => ipMode，界面注意同步
// 路由器WAN口可以与其他交换机或者是调制解调器相通
// 如果是其他交换机，那么路由器WAN口可以工作在DHCP或者静态IP模式下
// 如果是调制解调器，那么路由器WAN口通过二层发送PPPOE认证报文，并建立PPPOE协议通道获取公网IP配置，后续发送全都继续PPPOE协议发送

export class Router extends Node {}

Router.config({
  width: 72,
  height: 60,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/router.png'),
      width: 72,
      height: 60,
    },
    text: {
      refX: '50%',
      refY: 75,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '路由器',
      fontSize: 12
    },
  },
  ports: {
    items: [
      {
        group: 'inet',
        attrs: {
          rect: {
            y: 30,
            fill: PORT_FILL.LAN,
          },
          text: {          // 标签选择器
            text: 'LAN', // 标签文本
          },
        },
      },
      {
        group: 'inet',
        attrs: {
          rect: {
            y: 30,
            fill: PORT_FILL.WAN,
          },
          text: {          // 标签选择器
            x: 14,
            text: 'WAN', // 标签文本
          },
        },
      },
    ],
    groups: {
      inet: {
        markup: [
          {
            tagName: 'rect',
            selector: 'rect',
          },
          // {
          //   tagName: 'text',
          //   selector: 'text',
          // },
        ],

        position: {
          name: 'bottom',
        },

        label: {
          position: {
            name: 'bottom',
            args: {
              y: 60
            }
          },
        },

        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.DEFAULT,
            strokeWidth: 2,
            width: 16,
            height: 16,
          },
          label:{
            
          }
        },
      },
    },
  }
});

Graph.registerNode('Router', Router);

// 防火墙
class Firewall extends Node {}

Firewall.config({
  width: 90,
  height: 66,
  markup: [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/firewall.png'),
      width: 72,
      height: 60,
    },
    text: {
      refX: '50%',
      refY: 75,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      text: '防火墙',
      fontSize: 12,
    },
  },
  ports: {
    items: [
      {
        group: 'inner',
        attrs: {
          text: { text: '内网' },
        },
      },
      {
        group: 'outer',
        attrs: {
          text: { text: '外网' },
        },
      },
    ],
    groups: {
      inner: {
        markup: [
          { tagName: 'rect', selector: 'rect' },
        ],
        position: { name: 'left' },
        label: {
          position: {
            name: 'left',
            args: { x: -28, y: 0 },
          },
        },
        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.FIREWALL_IN,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -10,
            y: -8,
          },
          label: {
            fontSize: 10,
            fill: '#666',
          },
        },
      },
      outer: {
        markup: [
          { tagName: 'rect', selector: 'rect' },
        ],
        position: { name: 'right' },
        label: {
          position: {
            name: 'right',
            args: { x: 28, y: 0 },
          },
        },
        attrs: {
          rect: {
            magnet: true,
            stroke: 'gray',
            fill: PORT_FILL.FIREWALL_OUT,
            strokeWidth: 2,
            width: 16,
            height: 16,
            x: -6,
            y: -8,
          },
          label: {
            fontSize: 10,
            fill: '#666',
          },
        },
      },
    },
  },
});

Graph.registerNode('Firewall', Firewall);

// 图片节点基类
class ImgCell extends Node {}

const baseImgMarkup = [
    {
      tagName: 'image',
      selector: 'body',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ];

ImgCell.config({
  width: 90,
  height: 66,
  markup: baseImgMarkup,
  attrs: {
    body: {
      width: 72,
      height: 60,
    },
    text: {
      refX: '40%',
      refY: 75,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      fontSize: 12
    },
  },

});

Graph.registerNode('ImgCell', ImgCell);

// iot设备
// 1. 智能灯泡
class SmartBulb extends Node {}

SmartBulb.config({
  width: 20,
  height: 20,
  markup: [
    {
      tagName: 'path',
      selector: 'bulb',
    },
    {
      tagName: 'path',
      selector: 'border',
    },
    {
      tagName: 'text',
      selector: 'label',
    },
  ],
  attrs: {
    bulb: {
      d: 'm32,15.01786c-7.75976,0 -14.04878,6.39509 -14.04878,14.28571c0,5.16183 2.71097,9.83817 7.02988,12.37723l1.97012,1.16071l0,6.55134l10.09756,0l0,-6.55134l1.97012,-1.16071c4.3189,-2.53906 7.02988,-7.2154 7.02988,-12.37723c0,-7.89062 -6.28903,-14.28571 -14.04878,-14.28571l-0.00001,0z',
      fill: '#cccccc',
    },
    border: {
      d: 'm38.58537,56.98214l-13.17073,0c-0.24146,0 -0.43903,0.20089 -0.43903,0.44643l0,1.78571c0,0.98773 0.78476,1.78571 1.7561,1.78571l10.53659,0c0.97134,0 1.7561,-0.79799 1.7561,-1.78571l0,-1.78571c0,-0.24554 -0.19756,-0.44643 -0.43903,-0.44643zm-6.58537,-45.98214c-9.93841,0 -18,8.19754 -18,18.30357c0,6.77455 3.62195,12.68973 9,15.85379l0,6.46763c0,0.98773 0.78476,1.78571 1.7561,1.78571l14.4878,0c0.97134,0 1.7561,-0.79799 1.7561,-1.78571l0,-6.46763c5.37805,-3.16406 9,-9.07924 9,-15.85379c0,-10.10602 -8.06159,-18.30357 -18,-18.30357zm7.0189,30.68081l-1.97012,1.16071l0,6.55134l-10.09756,0l0,-6.55134l-1.97012,-1.16071c-4.3189,-2.53906 -7.02988,-7.2154 -7.02988,-12.37723c0,-7.89062 6.28903,-14.28571 14.04878,-14.28571s14.04878,6.39509 14.04878,14.28571c0,5.16183 -2.71097,9.83817 -7.02988,12.37723l0.00001,0z',
      fill: '#4F96EF',
    },
    text: {
      text: '智能灯泡',
      refX: 32,
      refY: 85,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      fontSize: 12
    },
  },
});

Graph.registerNode('SmartBulb', SmartBulb)

// 2. 空调
const AirConditioner = ImgCell.define({
  markup: [
    ...baseImgMarkup,
    {
      tagName: 'text',
      selector: 'temperature',
    },
  ],
  attrs: {
    body: {
      href: require('../../assets/icon/airconditioner.png'),
      width: 120,
      height: 90,
    },
    text: {
      text: '空调',
      refX: 60,
      refY: 95,
    },
    temperature: {
      text: '',
      refX: 75,
      refY: 35,
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      fontSize: 12,
    },
  },
})

Graph.registerNode('AirConditioner', AirConditioner)

// 3. 智能门锁
const SmartLock = ImgCell.define({
  attrs: {
    body: {
      href: require('../../assets/icon/lock.png'),
    },
    text: {
      text: '智能门锁',
    },
  },
})

Graph.registerNode('SmartLock', SmartLock)

// 4. 智能门铃
const SmartBell = ImgCell.define({
  attrs: {
    body: {
      href: require('../../assets/icon/doorbell.png'),
    },
    text: {
      text: '智能门铃',
    },
  },
})

Graph.registerNode('SmartBell', SmartBell)

// 5. 智能音箱
const SmartSpeaker = ImgCell.define({
  attrs: {
    body: {
      href: require('../../assets/icon/smartaudio.png'),
    },
    text: {
      text: '智能音箱',
    },
  },
})

Graph.registerNode('SmartSpeaker', SmartSpeaker)

// 6. 投影机
const Projector = ImgCell.define({
  attrs: {
    body: {
      href: require('../../assets/icon/projector.png'),
    },
    text: {
      text: '投影机',
    },
  },
})

Graph.registerNode('Projector', Projector)

// 7. 投影幕布
const Screen = ImgCell.define({
  attrs: {
    body: {
      href: require('../../assets/icon/screen_off.png'),
    },
    text: {
      text: '投影幕布',
    },
  },
})

Graph.registerNode('Screen', Screen)

// 指示灯
const IndicatorLight = Shape.Circle.define({
  width: 10,
  height: 10,
  attrs: {
    body: {
      fill: 'red',
      stroke: null,
    },
  },
  data: {
    disableMove: true,
  }
});

Graph.registerNode('IndicatorLight', IndicatorLight);